import { ImageInfo } from '@irohalab/mira-sdk-angular';

export const DEFAULT_RATIO = 10/8;

export function imageRatio(coverImage?: ImageInfo): number {
  if (!coverImage) {
    return DEFAULT_RATIO;
  }
  return Math.max(coverImage.height / coverImage.width, DEFAULT_RATIO);
}

export const DEFAULT_IMAGE_INFO = {
  url: '/assets/image-placeholder.png',
  width: 960,
  height: 796,
  dormantColor: '#3c3f41'
} as ImageInfo;

export function formatPublicTime(publicTime?: string): string {
  if (!publicTime) {
    return '';
  }
  const pt = publicTime.split('T');
  if (pt.length > 0) {
    return pt[0];
  }
  return publicTime;
}
